import { DashboardQuery, DashboardDataNormalized } from '@/models/dashboard';
import { DashboardService } from '@/services/DashboardService';

export interface DashboardState {
  data: DashboardDataNormalized;
}

export const DashboardModule: {
  state: DashboardState,
  mutations: any,
  actions: any,
} = {
  state: {
    data: [] as any,
  },
  mutations: {
    setData(state: DashboardState, data: any) {
      state.data = data;
    },
  },
  actions: {
    async loadDashboardType({ commit }: any, payload: DashboardQuery) {
      // @TODO get paginated data
      const data = await DashboardService.getDashboardDataByType(payload);
      commit('setData', data);
    },
  },
};
